<template>
  <mp-error v-if="isError === true" :style="getCustomStyle(startGameConfig)"></mp-error>
  <div v-else class="game-container" :id="startGameConfig.id" :style="getCustomStyle(startGameConfig)">
    <mp-loader :start-game-config="startGameConfig.loader" v-show="loading"></mp-loader>
    <model-obj
      ref="model"
      v-if="typeof startGameConfig.model.obj !== 'undefined' && startGameConfig.model.obj != null"
      @on-load="onLoad"
      @on-error="onError"
      :src="get3dFile(startGameConfig.model.obj)"
      :mtl="
        typeof startGameConfig.model.mtl !== 'undefined' && startGameConfig.model.mtl != null
          ? get3dFile(startGameConfig.model.mtl)
          : ''
      "
      :controls-options="tjsStageVUE.controlsOptions"
      :width="width"
      :height="height"
      :position="tjsStageVUE.worldPosition"
      :camera-position="tjsStageVUE.cameraPosition"
      :camera-rotation="tjsStageVUE.cameraRotation"
      :lights="tjsStageVUE.lights"
      :background-color="backgroundColor"
      :background-alpha="backgroundAlpha"
    ></model-obj>
    <model-three
      v-else-if="typeof startGameConfig.model.json !== 'undefined' && startGameConfig.model.json != null"
      @on-load="onLoad"
      @on-error="onError"
      :src="get3dFile(startGameConfig.model.json)"
      :controls-options="tjsStageVUE.controlsOptions"
      :width="width"
      :height="height"
      :lights="tjsStageVUE.lights"
      :background-color="backgroundColor"
      :background-alpha="backgroundAlpha"
    ></model-three>
    <mp-legend
      v-if="typeof startGameConfig.legend !== 'undefined' && startGameConfig.legend != null"
      :start-game-config="startGameConfig.legend"
    ></mp-legend>
    <mp-camera
      v-if="typeof startGameConfig.panelCamera !== 'undefined' && startGameConfig.panelCamera != null"
      :start-game-config="startGameConfig.panelCamera"
      :tjs-stage="tjsStageVUE"
    ></mp-camera>
    <div
      id="interactiveModal"
      v-if="typeof startGameConfig.interactive !== 'undefined' && startGameConfig.interactive != null"
    >
      <tr-step-by-step-comics :start-game-config="startGameConfig.interactive"></tr-step-by-step-comics>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TrStepByStepComics from '../StepByStep/TrStepByStepComics';
import mpLoader from '../../GameBaseElements/MpLoader/MpLoader';
import mpCamera from '../../GameBaseElements/MpControl/MpControlVUE';
import mpError from '../MpError/MpError';
import mpLegend from './MpLegend';
import * as THREE from 'three';
import { ModelObj, ModelThree } from 'vue-3d-model';
import defaultMixins from '../../mixins/defaultMixin';
import { tjsStageVUE } from '../../mixins3D/tjsStage';
export default {
  name: 'mp-model-show',
  mixins: [defaultMixins],
  components: { TrStepByStepComics, mpLoader, mpCamera, mpError, mpLegend, ModelObj, ModelThree },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isError: false,
      loading: true,
      tjsStageVUE: {},
      width: undefined,
      height: undefined,
      backgroundColor: 'rgb(255,255,255)',
      backgroundAlpha: 1,
      // requestId: false,
      intersected: null,
      models: [],
      // canvas: false,
      RAF: false,
    };
  },
  beforeMount() {
    try {
      this.init();
    } catch (e) {
      console.log(e);
      this.loading = false;
      this.isError = true;
    }
  },
  beforeDestroy() {
    this.tjsStageVUE.canvas.removeEventListener('mousemove', this.onMouseMove, true);
    this.tjsStageVUE.canvas.removeEventListener('click', this.onClick, true);
    cancelAnimationFrame(this.RAF);
    this.tjsStageVUE.beforeDestroy();
  },
  mounted() {},
  methods: {
    get3dFile(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    init() {
      this.tjsStageVUE = new tjsStageVUE(this.startGameConfig, this);
      this.tjsStageVUE.createLights();
    },
    onLoad() {
      try {
        for (let i in this.$children) {
          if (typeof typeof this.$children[i].wrapper === 'undefined' || this.$children[i].wrapper == null) {
            continue;
          }
          this.tjsStageVUE.setWorld(this.$children[i]);
          let object3d = this.$children[i].wrapper;
          for (let j in object3d.children) {
            if (typeof object3d.children[j] !== 'object' || typeof object3d.children[j] == null) {
              continue;
            }
            for (let k in object3d.children[j].children) {
              if (
                typeof object3d.children[j].children[k] !== 'object' ||
                typeof object3d.children[j].children[k] == null
              ) {
                continue;
              }
              if (
                typeof object3d.children[j].children[k].material.map != 'undefined' &&
                object3d.children[j].children[k].material.map != null
              ) {
                object3d.children[j].children[k].material.color.setStyle('#fff');
                object3d.children[j].children[k].material.startImage = new THREE.TextureLoader().load(
                  object3d.children[j].children[k].material.map.image.src
                );
              }
              object3d.children[j].children[k].material.startColor =
                object3d.children[j].children[k].material.color.clone();

              if (typeof this.startGameConfig.interactive === 'undefined' || this.startGameConfig.interactive == null) {
                continue;
              }

              let steps = document.getElementById('interactiveModal').getElementsByClassName('stepp-button');
              for (let l = 0; l < steps.length; l++) {
                if (steps[l].innerText != object3d.children[j].children[k].name) {
                  continue;
                }
                object3d.children[j].children[k].idStep = steps[l].id;
              }
            }
          }
          this.models.push(object3d);
        }
        this.tjsStageVUE.canvas = document.getElementById(this.startGameConfig.id).querySelector('canvas');
        if (typeof this.startGameConfig.interactive !== 'undefined' && this.startGameConfig.interactive != null) {
          this.tjsStageVUE.canvas.addEventListener('mousemove', this.onMouseMove, true);
          this.tjsStageVUE.canvas.addEventListener('click', this.onClick, true);
        }
        this.loading = false;
        if (this.tjsStageVUE.controlsOptions.autoRotate !== false) {
          this.tjsStageVUE.rotating = true;
          if (typeof this.startGameConfig.panelCamera === 'undefined' || this.startGameConfig.panelCamera == null) {
            this.animate();
          }
        }
        this.tjsStageVUE.world.update();
      } catch (e) {
        this.isError = true;
        this.loading = false;
        console.log(e);
      }
    },
    onError(e) {
      this.loading = false;
      this.isError = true;
      console.log(e);
    },
    onMouseMove(e) {
      if (typeof this.tjsStageVUE.world.camera == 'undefined' || this.tjsStageVUE.world.camera == null) {
        return;
      }
      for (let i in this.models) {
        if (typeof this.models[i] !== 'object') {
          continue;
        }
        for (let j in this.models[i].children) {
          if (typeof this.models[i].children[j] !== 'object') {
            continue;
          }
          for (let k in this.models[i].children[j].children) {
            if (typeof this.models[i].children[j].children[k] !== 'object') {
              continue;
            }
            this.models[i].children[j].children[k].material.color =
              this.models[i].children[j].children[k].material.startColor.clone();
            if (
              typeof this.models[i].children[j].children[k].material.map != 'undefined' &&
              this.models[i].children[j].children[k].material.map != null
            ) {
              this.models[i].children[j].children[k].material.map =
                this.models[i].children[j].children[k].material.startImage;
            }
          }
        }
      }

      let intersects = [];
      intersects = this.tjsStageVUE.findIntersectObjects(e);
      for (var i = 0; i < intersects.length; i++) {
        if (typeof intersects[i].object.material.map != 'undefined' && intersects[i].object.material.map != null) {
          intersects[i].object.material.map = this.tjsStageVUE.whiteMask;
        }
        intersects[i].object.material.color.setStyle(
          typeof this.startGameConfig.interactive.colorSelect !== 'undefined' &&
            this.startGameConfig.interactive.colorSelect != null
            ? this.startGameConfig.interactive.colorSelect
            : 'white'
        );
      }

      this.tjsStageVUE.rotating =
        intersects.length == 0 && this.tjsStageVUE.controlsOptions.autoRotate !== false ? true : false;
    },

    onClick(e) {
      let intersects = this.tjsStageVUE.findIntersectObjects(e);
      if (
        intersects.length == 0 ||
        typeof intersects[intersects.length - 1].object.idStep == 'undefined' ||
        intersects[intersects.length - 1].object.idStep == null
      ) {
        return;
      }

      document.getElementById(intersects[intersects.length - 1].object.idStep).click();
    },

    animate() {
      this.tjsStageVUE.rotate();

      this.RAF = requestAnimationFrame(this.animate);
    },

    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },

    resetGameAction() {
      this.tjsStageVUE.reset();
    },

    checkGameAction() {},
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
